import {notification} from 'antd'
import Language from "language"

const action = (actionName: React.ReactNode) => notification.success({
  message: actionName,
  description: Language.get('common.notificationSuccess.description.action'),
})

export default {action}
